import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import {
    getAdminEmpresa, getFinanceiroCaixa,
    getFinanceiroAgencia,
    getOperadorEmpresa,
    getPerfisVendedores, getVendedorAgencia, getVendedorEmpresa,
    PERFIL_ADMIN,
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';

import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';
import { getFinanceiroEmpresa } from '../../security/securityContext';

export class MenuEncomendas extends Component {

    render() {
        return (
            <div className="area-home">
                <Titulo texto="Encomendas Vexado Express" urlRetorno="/gestao-empresa" />
                <div className="row sistemas">
                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        ...getPerfisVendedores(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-cadastro-encomenda">
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons">&#xe8b6;</i>
                                        <h5 className='nm-longo-resize'>
                                            Nova encomenda
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Autorizacao>
                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroCaixa(this.props.empresaSelecionada.id),
                        getFinanceiroAgencia(this.props.empresaSelecionada.id),
                        getFinanceiroEmpresa(this.props.empresaSelecionada.id),
                        getVendedorAgencia(this.props.empresaSelecionada.id),
                        getVendedorEmpresa(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-encomendas">
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons"><QueryStatsOutlinedIcon className='css-icon' /></i>
                                        <h5 className='nm-longo-resize'>
                                            Gerenciar encomendas
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Autorizacao>
                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroEmpresa(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-configuracao-encomendas">
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <i className="material-icons custom-icons"><CorporateFareOutlinedIcon className='css-icon' /></i>
                                        <h5 style={{ fontSize: 14 }} className='nm-longo'>
                                            Configuração de encomendas
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Autorizacao>
                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroEmpresa(this.props.empresaSelecionada.id)]}
                        empresaSelecionada={this.props.empresaSelecionada}>
                        <div className="col-6 col-sm-6 col-md-3 mb-3">
                            <Link to="/painel-confirmar-entrega-encomendas">
                                <div className="card card-inicial ">
                                    <div className="card card-inicial-interno ">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" color='000' className="bi bi-chat-right-text" viewBox="0 0 16 16">
                                            <path d="M2 1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h9.586a2 2 0 0 1 1.414.586l2 2V2a1 1 0 0 0-1-1H2zm12-1a2 2 0 0 1 2 2v12.793a.5.5 0 0 1-.854.353l-2.853-2.853a1 1 0 0 0-.707-.293H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12z" />
                                            <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zM3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6zm0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" />
                                        </svg>
                                        <h5 style={{ fontSize: 16 }} className='nm-longo'>
                                            Informar entregas
                                        </h5>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </Autorizacao>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication
    }
}


export default withRouter(connect(mapStateToProps)(MenuEncomendas));
